// user-client/src/shared/utils/mobileViewportGuard.js
// 모바일 브라우저에서 input 포커스/두 손가락 제스처로 인한 강제 줌을 차단한다.

import { shouldUseMobileRuntimeFeatures } from './uiMode';

const LOCKED_VIEWPORT = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover';

function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

function shouldApplyMobileGuard() {
  if (!isBrowser()) return false;

  // ✅ 창 폭만 좁아진 데스크톱은 mobile UI를 쓸 수 있지만,
  // 실제 모바일 런타임처럼 viewport lock / pinch 차단을 적용하면 안 된다.
  return shouldUseMobileRuntimeFeatures();
}

function lockViewportScale() {
  if (!isBrowser() || !shouldApplyMobileGuard()) return;
  let meta = document.querySelector('meta[name="viewport"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'viewport');
    document.head.appendChild(meta);
  }
  if (!meta.dataset.npcOriginalContent) {
    meta.dataset.npcOriginalContent = meta.getAttribute('content') || '';
  }
  meta.setAttribute('content', LOCKED_VIEWPORT);
}

function preventPinchZoom() {
  if (!isBrowser() || !shouldApplyMobileGuard()) return;
  if (document.documentElement.dataset.npcPinchGuard === '1') return;
  document.documentElement.dataset.npcPinchGuard = '1';

  const prevent = (event) => {
    event.preventDefault?.();
  };

  const preventMultiTouch = (event) => {
    if (event?.touches && event.touches.length > 1) {
      event.preventDefault?.();
    }
  };

  // iOS Safari 전용 gesture 이벤트 대응
  document.addEventListener('gesturestart', prevent, { passive: false });
  document.addEventListener('gesturechange', prevent, { passive: false });
  document.addEventListener('gestureend', prevent, { passive: false });

  // Chromium/Android 및 일반 모바일 브라우저의 멀티터치 확대 대응
  document.addEventListener('touchmove', preventMultiTouch, { passive: false });
}

lockViewportScale();
preventPinchZoom();
